module.exports = __webpack_public_path__ + "static/media/pm_hc_physician_measure_1.129d5850.png";